import { render, staticRenderFns } from "./responsibility.vue?vue&type=template&id=0c030d6e&scoped=true&"
import script from "./responsibility.vue?vue&type=script&lang=js&"
export * from "./responsibility.vue?vue&type=script&lang=js&"
import style0 from "./responsibility.vue?vue&type=style&index=0&id=0c030d6e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c030d6e",
  null
  
)

export default component.exports